import Hero from '../components/Hero';
import Intro from '../components/Intro';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import Testimonials from '../components/Testimonials';

const HomePage = () => {
  return (
    <>
      <Hero />
      <Intro />
      <Features />
      <HowItWorks />
      <Testimonials />
    </>
  );
};

export default HomePage;
